<template>
  <a-card :bordered="false">
    <a-button type="primary" @click="showMapEvent">显示选择地图</a-button>
    <custom-paging-dragging-list
      :requestPromise="getGoodsPromise"
      :columns="columns"
      @draggable="onDraggable"
    >
      <template slot="info" slot-scope="rowItem">
        <div class="item-proInfo">
          <CustomImage :imageUrl="rowItem.record.proImg" :width="80" :height="80"></CustomImage>
          <div class="content-right">
            <a-tooltip placement="topLeft">
              <template slot="title">{{ rowItem.record.proName }}</template>
              <div class="pro_title">{{ rowItem.record.proName }}</div>
            </a-tooltip>
            <div class="bottom-box">
              <div class="pro_id">ID：{{ rowItem.record.proId }}</div>
              <div class="pro_tag">
                <span class="tag" v-if="rowItem.record.proSource!==0">分销</span>
                <span class="price-text">￥{{ rowItem.record.proPriceMin }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </custom-paging-dragging-list>
    <custom-baidu-map
      title="选择目标位置"
      :visible="showMap"
      :default-room="15"
      width="600px"
      :map-height="450"
      :showCenter="{}"
      map-key="WkPp7G2E2yGn6ugvHajD7qG2jxvigARP"
      @selected="onMapSelected"
      @cancel="showMap=false"
    ></custom-baidu-map>
  </a-card>
</template>

<script>
import CustomPagingDraggingList from '@/customComponents/CustomPagingDraggingList/CustomPagingDraggingList'


export default {
  name: 'TestPagingDraggingList',
  components: { CustomPagingDraggingList },
  data() {
    return {
      showMap: false,
      columns: [
        {
          title: '商品信息',
          dataIndex: 'info',
          scopedSlots: { customRender: 'info' },
          width: '45%'
        },
        {
          title: '收藏数',
          dataIndex: 'proFavoriteNum',
          align: 'center'
        },
        {
          title: '累计销量',
          dataIndex: 'proSales',
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'proCreateTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '180px',
          align: 'center',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  },
  mounted() {
  },
  methods: {
    getGoodsPromise(params) {
      return this.getHttpServices().getProService().post('api/v2/productManage/findProductList', params)
    },
    onDraggable(params) {
      console.error('=======params========', params)
    },
    showMapEvent() {
      this.showMap = true
    },
    onMapSelected(info) {
      console.error('=======onMapSelected========', info)
    }
  }

}
</script>
<style scoped lang="less">
.infoMain {
  position: relative;

  .infoText {
    position: absolute;
    bottom: 22px;
    left: 30px;
    height: 50px;
    width: 330px;
  }
}

.item-proInfo {
  display: flex;

  .content-right {
    flex: 1;
    margin-left: 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .pro_title {
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      -ms-text-overflow: ellipsis;
      text-overflow: ellipsis;
    }

    .bottom-box {
      .pro_id {
        font-size: 12px;
        color: #8f8f8f;
      }

      .pro_tag {
        display: flex;
        align-items: center;

        .tag {
          height: 20px;
          line-height: 20px;
          padding: 0 8px;
          font-size: 10px;
          color: #fff;
          border-radius: 2px;
          background-color: rgba(115, 209, 61, 1);
          margin-right: 8px;
        }

        .price-text {
          color: #ff7700;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
<style lang="less">
.infoMain {
  .ant-table-tbody > tr > td {
    padding: 8px 8px;
  }
}
</style>